<template>
  <div class="score">
    <Loading v-if="loading" />
    <div class="bgc top_div">
      <div class="title">
        <div class="sort_son_title">
          {{ itemTitle }}
        </div>
        <div class="right_div">
          <a-button
            v-if="data && data.length"
            class="btn"
            type="primary"
            ghost
            @click="importTo"
          >
            {{ $t('exam.downbtn') + itemTitle + $t('exam.biao') }}
          </a-button>
        </div>
      </div>
      <div v-show="data.length" class="echarts">
        <div :id="id" class="echarts_list"></div>
      </div>
      <NotData v-if="!data.length && !loading" />
    </div>
    <div v-if="datatable && datatable.length" class="bgc table_div">
      <Table :columns="columns" :pagination="false" :data="datatable" />
    </div>
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import * as echarts from 'echarts'
  import Loading from '@comp/loading'
  import { getCol } from '@utils/unite.js'

  export default {
    name: 'ClassTotal',
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      },
      cache: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        data: [],
        datatable: [],
        // chartList: [],
        arrMinScore: [],
        arrMaxScore: [],
        splitNum: 7,
        barRadius: [6, 6, 0, 0],
        titles: [],
        currentClass: {},
        charts: null,
        cacheData: false //是否缓存数据
      }
    },
    watch: {
      $route: {
        handler(newData, oldData) {
          var groupStatus = newData.query.dId === oldData.query.dId
          var subjectStatus =
            newData.query.subjectId === oldData.query.subjectId
          if (
            groupStatus &&
            subjectStatus &&
            newData.query.classId !== oldData.query.classId
          ) {
            this.cacheData = true
          }
        }
      }
    },
    mounted() {
      // 获取折线统计图数据
      let params = {
        classId: this.id == 'chartM' ? this.$route.query.classId : 0
      }
      this.getTable(params)
      // 获取table表格数据
      this.getList()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length >= num) {
          let endVal = num === 1 ? 5 : +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              xAxisIndex: [0],
              handleIcon: `M 100, 100
                                m -75, 0
                                a 75,75 0 1,0 150,0
                                a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 40, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: 'rgba(203, 214, 255, 0.6)', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      },

      getTable(par) {
        this.loading = true
        let {
          meId,
          dId,
          classId,
          seId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let obj = {
          chartM: [
            //试卷整体分析
            'questionScoreRate',
            'questionScoreRateUnion',
            'questionScoreRateUnion'
          ],
          chartK: [
            'scoretrendimage',
            'scoretrendimageUnion',
            'scoretrendimageUnion'
          ]
        }
        let url = obj[this.id][examIsActive]
        let params = {
          meId,
          classId: par.classId,
          seId,
          campusId,
          groupId: dId || 0
        }
        // 试卷整体分析，试题得分率趋势
        // let url = this.id == 'chartM' ? 'questionScoreRate' : 'scoretrendimage'
        axios({
          url,
          params,
          loading: false,
          getCache: this.cache,
          cacheData: true
        })
          .then(res => {
            this.loading = false
            if (res.data) {
              this.loading = false
              if (this.id == 'chartM') {
                // 试卷整体分析
                // res.data.classData  班级数据
                // res.data.gradeData  年级数据
                this.data = res.data.gradeData || []
                let gradeData = res.data.gradeData || []
                let classData = res.data.classData || []
                let legendData = []
                let seriesData = []

                this.titles = res.data.gradeData.map(item => item.displayName)
                let gdata = {
                  name: `${
                    this.$store.state.unionReport
                      ? this.$t('exam.unionTitle')
                      : this.$t('exam.grade')
                  }`,
                  type: 'line',
                  // showSymbol: false,
                  symbol: 'circle',
                  symbolSize: 8,
                  smooth: true,
                  data: []
                }

                gradeData.forEach(item => {
                  gdata.data.push(item.rate)
                })

                seriesData.push(gdata)
                if (classId > 0) {
                  legendData = [
                    `${
                      this.$store.state.unionReport
                        ? this.$t('exam.unionTitle')
                        : this.$t('exam.grade')
                    }`,
                    res.data.className
                  ]
                  let cdata = {
                    name: res.data.className,
                    type: 'line',
                    // showSymbol: false,
                    symbol: 'circle',
                    symbolSize: 8,
                    smooth: true,
                    data: []
                  }
                  classData.forEach(item => {
                    cdata.data.push(item.rate)
                  })
                  seriesData.push(cdata)
                }

                this.renderChart(legendData, this.data, seriesData)
              } else {
                // 试题得分率趋势
                let legendData = res.data.legend
                let data = []
                res.data.xTitle.forEach(item => {
                  data.push({
                    displayName: item,
                    rate: 100
                  })
                })
                this.data = data
                this.titles = this.data.map(item => item.displayName)
                let seriesData = res.data.data || []
                seriesData.forEach(sc => {
                  if (classId * 1 && sc.classId == classId) {
                    this.currentClass = { ...sc }
                  }

                  // sc.showSymbol = true
                  sc.symbol = 'circle'
                  sc.symbolSize = 8
                  sc.smooth = true
                })
                this.renderChart(legendData, this.data, seriesData)
              }
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      renderChart(legendData, list, seriesData) {
        let avg = []
        let legendBs = Math.ceil(legendData.length / 10)
        let legendHeight = 400 + legendBs * 30
        this.data.forEach(item => {
          avg.push(item.rate)
        })
        let lenObj = {}

        let a = `${
          this.$store.state.unionReport
            ? this.$t('exam.unionTitle')
            : this.$t('exam.grade')
        }`
        legendData.forEach(item => {
          if (
            this.currentClass.name &&
            this.currentClass.name != item &&
            item != a
          ) {
            lenObj[item] = false
          } else {
            lenObj[item] = true
          }
        })
        this.$nextTick(() => {
          this.charts = echarts.init(document.getElementById(this.id))
          let option = {
            color: this.$store.state.echartsColor,
            tooltip: {
              trigger: 'axis',
              confine: true, //是否将 tooltip 框限制在图表的区域内
              enterable: true, //鼠标可进入提示框
              borderWidth: 0, //设置自定义边框宽度
              backgroundColor: 'transparent', //设置自定义背景
              extraCssText:
                //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
                'backdrop-filter: blur(10px);max-height:400px;overflow-y:auto;',
              formatter: params => {
                var relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${params[0].name}:</div>`
                for (var i = 0, l = params.length; i < l; i++) {
                  relVal += `<div class="toolTip">${params[i].marker}${params[i].seriesName}：${params[i].value}</div>`
                }
                return relVal
              }
            },
            legend: {
              data: legendData,
              selected: {
                ...lenObj
              }
            },
            xAxis: {
              type: 'category',
              boundaryGap: true,
              data: this.titles
            },
            yAxis: {
              type: 'value',
              scale: true,
              name: this.$t('exam.scoreRate'),
              max: 100,
              min: 0,
              nameTextStyle: {
                color: '#333'
              }
            },
            series: seriesData
          }
          this.beforeEchart(option, 100, [...avg])
          this.cScroll(option, this.titles, 10)
          this.charts.setOption(option)
          this.charts.resize({ height: legendHeight })
        })
      },

      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 25 + 34
        }
        //echarts距离处理
        data.grid = {
          top: data.legend.data.length ? top : 34,
          bottom: 28,
          left: '3.5%',
          right: '3.5%'
        }
        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            xDataDispose(item)
          })
        } else {
          xDataDispose(data.xAxis)
        }
        //x轴数据处理
        function xDataDispose(xData) {
          if (!xData.axisLabel) xData.axisLabel = {}
          xData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          xData.axisTick = {
            show: false
          }
          !xData.offset && (xData.offset = 4)
          if (!xData.axisLine) {
            xData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#A78BFA', '#fff'],
                opacity: 0.04
              }
            }
          }
        }

        //分割处理

        // 处理背景图间隔
        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            data.yAxis.interval = splitVal
            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = value => {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      getList() {
        this.loading = true
        // examIsActive 1  校端考试    2  校端联考   3  区域端联考
        let { meId, dId, seId, examIsActive = 1, campusId } = this.$route.query
        let obj = {
          chartM: [
            //试卷整体分析
            'testPaperOverallAnalysis',
            'testPaperOverallAnalysisUnion',
            'testPaperOverallAnalysisUnion'
          ],
          chartK: ['scoretrend', 'scoretrendUnion', 'scoretrendUnion']
        }
        //获取分数段,位次段
        let params = {
          meId,
          classId: 0,
          seId,
          campusId,
          groupId: dId || 0
        }
        // if (this.id == 'chartM') {
        //   params = {
        //     meId,
        //     classId: 0,
        //     seId,
        //     groupId: dId || 0
        //   }
        // } else {
        // params = {
        //   meId,
        //   classId: 0,
        //   seId,
        //   groupId: dId || 0
        // }
        // }

        // 试卷整体分析，试题得分率趋势
        let url = obj[this.id][examIsActive]
        axios({
          url,
          params,
          loading: false,
          getCache: this.cache,
          cacheData: this.cacheData
        }).then(res => {
          if (res.status) {
            // this.loading = false
            if (this.id == 'chartM') {
              // 试卷整体分析
              let columnsA = getCol(url) || [
                {
                  title: this.$t('exam.chartMolum[0]'),
                  dataIndex: 'type',
                  fixed: 'left',
                  key: 'type',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[1]'),
                  dataIndex: 'code',
                  fixed: 'left',
                  key: 'code',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[2]'),
                  dataIndex: 'studentNum',
                  key: 'studentNum',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[3]'),
                  dataIndex: 'fullScore',
                  key: 'fullScore',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[4]'),
                  dataIndex: 'avgScore',
                  key: 'avgScore',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[5]'),
                  dataIndex: 'difficulty',
                  key: 'difficulty',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[6]'),
                  dataIndex: 'bzc',
                  key: 'bzc',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[7]'),
                  dataIndex: 'maxScore',
                  key: 'maxScore',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[8]'),
                  dataIndex: 'minScore',
                  key: 'minScore',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[9]'),
                  dataIndex: 'mfenNum',
                  key: 'mfenNum',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[10]'),
                  dataIndex: 'mfenNumbili',
                  key: 'mfenNumbili',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[11]'),
                  dataIndex: 'bfenNum',
                  key: 'bfenNum',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[12]'),
                  dataIndex: 'bfenNumbili',
                  key: 'bfenNumbili',
                  width: 100
                },
                {
                  title: this.$t('exam.chartMolum[13]'),
                  dataIndex: 'zfenNum',
                  key: 'zfenNum',
                  width: 80
                },

                {
                  title: this.$t('exam.chartMolum[14]'),
                  dataIndex: 'zfenNumbili',
                  key: 'zfenNumbili',
                  width: 100
                }
              ]

              if (examIsActive * 1 == 1) {
                columnsA.splice(7, 0, {
                  title: '差异系数',
                  dataIndex: 'cv',
                  key: 'cv',
                  width: 100
                })
                columnsA.splice(6, 0, {
                  title: '区分度',
                  dataIndex: 'discrimination',
                  key: 'discrimination',
                  width: 100
                })
              }
              this.columns = columnsA
              this.datatable = res.data || []
            } else {
              // 试题得分率趋势
              this.datatable = []
              let columnsB = getCol(url) || [
                {
                  title: this.$t('exam.chartKolum[0]'),
                  dataIndex: 'qNum',
                  fixed: 'left',
                  key: 'qNum',
                  width: 100
                },
                {
                  title: this.$t('exam.chartKolum[1]'),
                  dataIndex: 'qName',
                  fixed: 'left',
                  key: 'qName',
                  width: 100
                },
                {
                  title: this.$t('exam.chartKolum[2]'),
                  dataIndex: 'qAnswer',
                  key: 'qAnswer',
                  width: 100
                },
                {
                  title: this.$t('exam.chartKolum[3]'),
                  dataIndex: 'qFullScore',
                  key: 'qFullScore',
                  width: 100
                },
                {
                  title: this.$t('exam.chartKolum[4]'),
                  dataIndex: 'qGradeAvgScore',
                  key: 'qGradeAvgScore',
                  width: 100
                },
                {
                  title: this.$t('exam.chartKolum[5]'),
                  dataIndex: 'diffValue',
                  key: 'diffValue',
                  width: 100
                }
              ]
              this.columns = columnsB
              let tableData = res.data.data || []
              if (tableData.length) {
                res.data.classNames.forEach(item => {
                  this.columns.push({
                    title: item,
                    children: [
                      {
                        title: this.$t('exam.chartKolum[6]'),
                        dataIndex: item + 'avgScore',
                        key: item + 'avgScore',
                        align: 'center',
                        width: 100
                      },
                      {
                        title: this.$t('exam.chartKolum[7]'),
                        dataIndex: item + 'scoreRate',
                        key: item + 'scoreRate',
                        align: 'center',
                        width: 100
                      }
                    ]
                  })
                })

                tableData.forEach(item => {
                  item.list.forEach(col => {
                    item[col.className + 'avgScore'] = col.avgScore
                    item[col.className + 'scoreRate'] = col.scoreRate
                  })
                })
                this.datatable = tableData
              }
            }
          }
        })
        // .catch(() => {
        //   setTimeout(() => {
        //     this.loading = false
        //   }, 200)
        // })
      },

      // 下载数据
      importTo() {
        let { meId, seId, dId, examIsActive = 1, campusId } = this.$route.query
        let obj = {
          chartM: [
            //试卷整体分析
            'exportscoreprintsingle',
            'exportscoreprintsingleUnion',
            'exportscoreprintsingleUnion'
          ],
          chartK: [
            'exportscoretrend',
            'exportscoretrendUnion',
            'exportscoretrendUnion'
          ]
        }
        let api = obj[this.id][examIsActive]
        let queryParams = {
          meId,
          classId: 0,
          seId,
          groupId: dId || 0,
          campusId
        }
        let queryList = []
        for (let q in queryParams) {
          if (queryParams[q] !== undefined) {
            queryList.push(`${q}=${queryParams[q]}`)
          }
        }
        let url =
          `${ApiXy.defaulteApi.host}${ApiXy.defaulteApi.path[api]}?` +
          queryList.join('&') +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 4px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  .score {
    height: 100%;
    .top_div {
      min-height: 400px;
      .echarts {
        .echarts_list {
          width: 100%;
          min-height: 400px;
        }
      }
    }
    .table_div {
      margin-top: @padding-sm;
    }
  }
</style>
